/* global localStorage */
import ApiService from '@/common/api.service'

import { FECTH_SIDEBAR, FECTH_NAME_SIDEBAR } from '@/store/actions.type'
import { SET_ERROR, SET_SIDEBAR,SET_NAME_SIDEBAR, SET_TABLE } from '@/store/mutations.type'

const state = {
    showSidebar: false,
    sidebar: null,
    namesidebar: null,
    table: null,
    errors: null
}

const getters = {
    getSidebar(state) {
        return state.sidebar
    },
    getNameSidebar(state) {
        return state.namesidebar
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error
    },
    [SET_SIDEBAR](state, sidebar) {
        state.sidebar = sidebar
        state.errors = {}
    },
    [SET_NAME_SIDEBAR](state, sidebar) {
        state.namesidebar = sidebar
        state.errors = {}
    },
    [SET_TABLE](state, table) {
        localStorage.setItem('table', table)
        state.table = table
        state.errors = {}
    }
}

const actions = {
    [FECTH_SIDEBAR](context, data) {

        context.commit(SET_TABLE, data.table)

        if (this.sidebar) {
            return this.getSidebar()
        }

        return new Promise((resolve) => {
            ApiService
            .post('dashboard/sidebar', data)
            .then((data) => {
                context.commit(SET_SIDEBAR, data.data)
                resolve(data.data)
            })
            .catch((data) => {
                context.commit(SET_ERROR, data)
            })
        })
    },
    [FECTH_NAME_SIDEBAR](context, data) {
        context.commit(SET_NAME_SIDEBAR, data)
    }
}

export default {
    state,
    mutations,
    getters,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js